import { isSNS } from "@/utils/utils";
import React from "react";
import bgSNS from "../assets/SVG/bgSNS.svg";
import footer_SNS from "../assets/SVG/footer_SNS.svg";
import KYC from "../assets/SVG/KYC.svg";
import KYCL from "../assets/SVG/KYCLeonext.svg";
import { RoutesPathList } from "@/config/routes/Routes";
import { useNavigate } from "react-router-dom";
import logo from "../assets/SVG/Logo_new.svg";

const KYC_Completed: React.FC = () => {
  const navigate = useNavigate();

  const handleDone = () => {
    navigate(
      isSNS() ? RoutesPathList.ExchangeSNS : RoutesPathList.ExchangePhone
    );
  };
  return isSNS() ? (
    <div
      className="overflow-hidden pt-[5rem] min-h-screen bg-[#1C1C1C] pb-[6rem] flex flex-col items-center"
      style={{
        backgroundImage: `url(${bgSNS})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex flex-col gap-24">
        <img src={footer_SNS} />
        <div className="flex flex-col gap-4 mt-[4rem]">
          <img src={KYC} />
          <div className="text-white text-[1.1875rem]">KYC Completed!</div>
        </div>
      </div>
      <button
        type="submit"
        className="button__green cursor-pointer w-[19.4375rem] !h-[3.5625rem] !mt-[8rem] !bg-[#8AFEFD] !text-[black] font-[inter] font-[600]`"
        onClick={handleDone}
      >
        Done
      </button>
    </div>
  ) : (
    <div className="overflow-hidden pt-[5rem] min-h-screen bg-[#fff] pb-[6rem] flex flex-col items-center">
      <div className="flex flex-col gap-24">
        <img src={logo} />
        <div className="flex flex-col items-center gap-4 mt-[4rem]">
          <img src={KYCL} />
          <div className="text-[#202A43] text-[1.1875rem] font-[700]">KYC Completed!</div>
        </div>
      </div>
      <button
        type="submit"
        className="button--blue !w-[10.3125rem] !h-[3.3125rem] !mt-[8rem]"
        onClick={handleDone}
      >
        Done
      </button>
    </div>
  );
};

export default KYC_Completed;
